import * as React from 'react'

function SvgOrbitControls(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={70} height={70} viewBox="12 12 78 78" fill="none" {...props}>
            {/* Central cube */}
            <g>
                <polygon points="50,30 70,40 70,60 50,70 30,60 30,40" fill="currentColor" opacity="0.25"/>
                <polygon points="50,30 70,40 50,50 30,40" fill="currentColor" opacity="0.45"/>
                <polygon points="50,50 70,40 70,60 50,70" fill="currentColor" opacity="0.35"/>
                <polygon points="50,50 30,40 30,60 50,70" fill="currentColor" opacity="0.55"/>
                <polyline points="50,30 50,50 50,70" stroke="currentColor" strokeWidth="1.5" opacity="0.7" fill="none"/>
            </g>
            {/* Orbit arrows */}
            <g>
                <path d="M50 15 A35 35 0 0 1 85 50" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.7"/>
                <polygon points="85,50 81,48 83,52" fill="currentColor"/>
                <path d="M50 85 A35 35 0 0 1 15 50" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.7"/>
                <polygon points="15,50 19,52 17,48" fill="currentColor"/>
                <path d="M50 15 A35 35 0 0 0 15 50" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.7"/>
                <polygon points="50,15 52,19 48,17" fill="currentColor"/>
                <path d="M50 85 A35 35 0 0 0 85 50" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.7"/>
                <polygon points="50,85 48,81 52,83" fill="currentColor"/>
            </g>
        </svg>
	)
}

export default SvgOrbitControls
